// "error" is a fatal init failure (missing/invalid link token, init request
// failed) -- there's no session, so there's nothing to render but a dead
// end. "failed" is a credential validation failure -- there IS a session,
// so it gets a dedicated retry screen that leads back to "enter_credentials"
// instead of dead-ending like "error" does.
export type ConnectStep =
  | "init"
  | "intro"
  | "select_provider"
  | "select_state"
  | "enter_credentials"
  | "success"
  | "failed"
  | "error";

export interface Provider {
  id: string;
  name: string;
  states: string[];
}

export interface CredentialField {
  field: string;
  label: string;
  type: string;
}

export interface ConnectSession {
  sessionId: string;
  organizationName: string;
  organizationLogoUrl: string | null;
  providers: Provider[];
  isSandbox: boolean;
}

export interface ConnectState {
  step: ConnectStep;
  session: ConnectSession | null;
  selectedProvider: Provider | null;
  selectedState: string | null;
  credentials: Record<string, string>;
  error: string | null;
  publicToken: string | null;
  connectionId: string | null;
  submitting: boolean;
}

// Credential fields per provider
export const PROVIDER_CREDENTIAL_FIELDS: Record<string, CredentialField[]> = {
  metrc: [{ field: "user_api_key", label: "User API Key", type: "password" }],
  biotrack: [
    { field: "username", label: "Username", type: "text" },
    { field: "password", label: "Password", type: "password" },
  ],
};

// State names for display
export const STATE_NAMES: Record<string, string> = {
  CA: "California",
  CO: "Colorado",
  MI: "Michigan",
  OK: "Oklahoma",
  OR: "Oregon",
  MA: "Massachusetts",
  MD: "Maryland",
  MO: "Missouri",
  NV: "Nevada",
  IL: "Illinois",
  NM: "New Mexico",
  HI: "Hawaii",
  NH: "New Hampshire",
};
